import angular from 'angular';
import tableGridDropdownCellComponent from './tableGridDropdownCell.component';

let tableGridDropdownCellModule = angular.module('tableGridDropdownCell', []).directive('tableGridDropdownCell', tableGridDropdownCellComponent);

export default tableGridDropdownCellModule;



// WEBPACK FOOTER //
// ./app/components/tableGridDropdownCell/tableGridDropdownCell.js